<ng-container>
    <h1 mat-dialog-title
        class="draggable-dialogue-header title-h"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        {{this.DialogueTitle}}
    </h1>

    <!-- Use the site milestone config component. -->
    <app-site-milestone-config [site]="this.Site"
                               [milestone]="this.Milestone"
                               [availableMilestoneNames]="this.AvailableMilestoneNames"
                               [schedulerAvailable]="this.SchedulerAvailable"
                               (milestoneChanged)="this.milestoneChanged($event)"></app-site-milestone-config>

    <div class="buttons-div">
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.SaveDisabled"
                (click)="this.save()">
            {{this.SaveButtonTitle}}
        </button>

        <button mat-flat-button
                class="basic"
                style="margin-left: 10px;"
                (click)="this.cancel()">
            Cancel
        </button>

        <span class="scheduler-available-message-span">{{this.SchedulerAvailableMessage}}</span>
    </div>

</ng-container>
